import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './style.css';

import founder from '../../assets/medal/founder.png';
import AnimatedAtaric from '../shared/AnimatedAtaric';
import { hasNewProgressReport, markProgressOpened } from '../../libs/progressStorage';
import analytics from '../../libs/analytics';

function Conversation({ user }: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showNovoBadge, setShowNovoBadge] = useState(false);

  useEffect(() => {
    setShowNovoBadge(hasNewProgressReport());
  }, [location.pathname]);

  function chat(payload = {}) {
    navigate('/chat', { state: payload });
  }

  function chatBrazilianMode() {
    analytics.conversationModeSelected('beginner');
    navigate('/chat', { state: { brazilianMode: true } });
  }

  function goToProgress() {
    analytics.pageViewed('progress');
    markProgressOpened();
    setShowNovoBadge(false);
    navigate('/progresso');
  }

  function goToEnglishRoadmap() {
    analytics.pageViewed('english_roadmap');
    navigate('/mapas-mentais');
  }

  return (
    <div className="Conv-page">
      {/* Hero mascot area */}
      <div className="Conv-hero">
        <div className="Conv-hero-glow" />
        <div className="Conv-pet-container">
          {(user && user.isFounder) ? (
            <img src={founder} className="App-atari" alt="founder" />
          ) : (
            <AnimatedAtaric size="large" className="mb-0" context="home" />
          )}
        </div>
      </div>

      {/* Mode selection cards */}
      <div className="Conv-modes">
        <button className="Conv-card Conv-card--beginner" onClick={chatBrazilianMode}>
          <div className="Conv-card-icon">
            <i className="fa-solid fa-comments" />
          </div>
          <div className="Conv-card-body">
            <span className="Conv-card-title">BEGINNER</span>
            <span className="Conv-card-desc">Conversação Guiada</span>
          </div>
          <div className="Conv-card-level">
            <span className="Conv-card-dot Conv-card-dot--on" />
            <span className="Conv-card-dot" />
            <span className="Conv-card-dot" />
          </div>
          <i className="fa-solid fa-chevron-right Conv-card-arrow" />
        </button>

        <button className="Conv-card Conv-card--advanced" onClick={() => { analytics.conversationModeSelected('advanced'); chat(); }}>
          <div className="Conv-card-icon Conv-card-icon--gold">
            <i className="fa-solid fa-bolt" />
          </div>
          <div className="Conv-card-body">
            <span className="Conv-card-title">ADVANCED</span>
            <span className="Conv-card-desc">Conversação 100% em Inglês</span>
          </div>
          <div className="Conv-card-level">
            <span className="Conv-card-dot Conv-card-dot--gold Conv-card-dot--on" />
            <span className="Conv-card-dot Conv-card-dot--gold Conv-card-dot--on" />
            <span className="Conv-card-dot Conv-card-dot--gold Conv-card-dot--on" />
          </div>
          <i className="fa-solid fa-chevron-right Conv-card-arrow" />
        </button>

        <button className="Conv-card Conv-card--land" onClick={() => { analytics.ataricLandClicked(); window.open('https://ataric-land.lovable.app/', '_blank'); }}>
          <div className="Conv-card-icon Conv-card-icon--land">
            <i className="fa-solid fa-gamepad" />
          </div>
          <div className="Conv-card-body">
            <span className="Conv-card-title">ATARIC LAND</span>
            <span className="Conv-card-desc">Aprenda jogando</span>
          </div>
          <i className="fa-solid fa-arrow-up-right-from-square Conv-card-arrow" />
        </button>

        <button className="Conv-card Conv-card--roadmap" onClick={goToEnglishRoadmap}>
          <div className="Conv-card-icon Conv-card-icon--roadmap">
            <i className="fa-solid fa-map" />
          </div>
          <div className="Conv-card-body">
            <span className="Conv-card-title">ENGLISH ROADMAP</span>
            <span className="Conv-card-desc">Mapas mentais · Inglês</span>
          </div>
          <i className="fa-solid fa-chevron-right Conv-card-arrow" />
        </button>
      </div>

      {/* Progress card */}
      <button className="Conv-progress-card" onClick={goToProgress}>
        <div className="Conv-progress-icon">
          <i className="fa-solid fa-chart-line" />
        </div>
        <div className="Conv-card-body">
          <span className="Conv-card-title">MY PROGRESS</span>
          <span className="Conv-card-desc">Veja sua Evolução</span>
        </div>
        {showNovoBadge && <span className="Conv-badge">NOVO!</span>}
        <i className="fa-solid fa-chevron-right Conv-card-arrow" />
        <span className="Conv-progress-shimmer" aria-hidden />
      </button>
    </div>
  );
}

export default Conversation;
